import {
  faEnvelope,
  faHeadset,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

export const contactCards = [
  {
    icon: faEnvelope,
    title: "Chat to Sales",
    description: "Speak to our friendly team.",
    contact: "mailto:hello@projectoptions.in",
  },
  {
    icon: faHeadset,
    title: "Chat to Support",
    description: "We are here to help.",
    contact:
      "https://api.whatsapp.com/message/ET5H2XZET4X2F1?autoload=1&app_absent=0",
  },
  // {
  //   icon: faPhone,
  //   title: "Call Us",
  //   description: "Mon-Fri 8am to 5pm",
  //   contact: "+91 9942993654",
  // },
];

export const videoTutorials = [
  {
    title: "How to Add Broker?",
    description: "Learn how to link your broker account.",
    thumbnail:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/b92c13ca0cd67cd41449e2a675c1a950e8b1d801b7e46432211f0ba88c43f5a0",
    videoUrl: "https://www.youtube.com/watch?v=EOcaDjvHg-c&t=1s",
  },
  {
    title: "What is Good to Enter?",
    description: "Understand entry strategies in trading.",
    thumbnail:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/b92c13ca0cd67cd41449e2a675c1a950e8b1d801b7e46432211f0ba88c43f5a0",
    videoUrl: "https://www.youtube.com/watch?v=EOcaDjvHg-c&t=1s",
  },
  {
    title: "Why Option Clock?",
    description: "Discover the benefits of using Option Clock.",
    thumbnail:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/b92c13ca0cd67cd41449e2a675c1a950e8b1d801b7e46432211f0ba88c43f5a0",
    videoUrl: "https://www.youtube.com/watch?v=EOcaDjvHg-c&t=1s",
  },
  {
    title: "Subscription Renewal",
    description: "Steps to renew your subscription.",
    thumbnail:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/b92c13ca0cd67cd41449e2a675c1a950e8b1d801b7e46432211f0ba88c43f5a0",
    videoUrl: "https://www.youtube.com/watch?v=EOcaDjvHg-c&t=1s",
  },
];
export const vidAnalysis = [
  {
    title: "Verified PnL For Q1 - April'24 to June'24",
    description: "Explaination of April to June 2024 VERIFIED Profits.",
    thumbnail:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/b92c13ca0cd67cd41449e2a675c1a950e8b1d801b7e46432211f0ba88c43f5a0",
    videoUrl: "https://www.youtube.com/watch?v=EOcaDjvHg-c&t=1s",
  },
];
